import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-as-center p-text-center p-m-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.componentLoading,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.componentLoading) = $event)),
    modal: true,
    showHeader: false,
    closable: false,
    class: "modal-loading"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ProgressSpinner, {
            style: {"width":"60px","height":"60px"},
            strokeWidth: "5",
            fill: "#ffffff",
            animationDuration: ".8s"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}